
// New-window link warnings (WCAG F22). inc/new-window-links.php applies the same
// rules to the served HTML; this covers links that scripts add after load.
const NEW_WINDOW_NOTE_CLASS = 'pmcscm-new-window-note';
const NEW_WINDOW_NOTE_TEXT = '(opens in a new window)';

function normalizeHost(host) {
  return host.toLowerCase().replace(/^www\./, '');
}

function isSameSiteLink(link) {
  // No href yet (a script may set it later): treat as external, like the PHP filter.
  if (!link.hasAttribute('href')) {
    return false;
  }

  const href = link.getAttribute('href').trim();
  if (href === '' || href.startsWith('#')) {
    return true;
  }

  try {
    const url = new URL(href, document.baseURI);
    return ['http:', 'https:'].includes(url.protocol) && normalizeHost(url.hostname) === normalizeHost(window.location.hostname);
  } catch (error) {
    return false;
  }
}

function markNewWindowLink(link) {
  if (link.querySelector('img')) {
    link.classList.add('has-image');
  }

  if (isSameSiteLink(link)) {
    link.removeAttribute('target');
    link.querySelectorAll(`.${NEW_WINDOW_NOTE_CLASS}`).forEach((note) => note.remove());
    const sameSiteLabel = link.getAttribute('aria-label');
    if (sameSiteLabel && sameSiteLabel.endsWith(` ${NEW_WINDOW_NOTE_TEXT}`)) {
      link.setAttribute('aria-label', sameSiteLabel.slice(0, -NEW_WINDOW_NOTE_TEXT.length - 1));
    }
    return;
  }

  const label = (link.getAttribute('aria-label') || '').trim();
  if (label) {
    if (!/new\s+(window|tab)/i.test(label)) {
      link.setAttribute('aria-label', `${label} ${NEW_WINDOW_NOTE_TEXT}`);
    }
    return;
  }

  if (!link.querySelector(`.${NEW_WINDOW_NOTE_CLASS}`)) {
    const note = document.createElement('span');
    note.className = NEW_WINDOW_NOTE_CLASS;
    note.textContent = ` ${NEW_WINDOW_NOTE_TEXT}`;
    link.append(note);
  }
}

function markNewWindowLinks(root) {
  if (root.matches && root.matches('a[target="_blank"]')) {
    markNewWindowLink(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll('a[target="_blank"]').forEach(markNewWindowLink);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  markNewWindowLinks(document.body);

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes') {
        markNewWindowLinks(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          markNewWindowLinks(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'target', 'aria-label'] });

  const alertBanner = document.querySelector('.alert-banner');

  if (!alertBanner) {
    return;
  }

  document.querySelector('.mega-toggle-animated').addEventListener('click', function() {
    if (this.getAttribute('aria-expanded') === 'true') {
      return;
    }

    document.querySelector('ul.mega-menu').style.top = `${ 131 + alertBanner.offsetHeight }px`;
  });
}); 